






































import { Component, Mixins } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import deleteUserMutation from '~/mutations/deleteUser.gql';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({
  components: { TwoFactorAuthInputPrompt },
})
export default class AdvancedSettings extends Mixins(AuthQuery) {
  @State(profile => profile.user.walletExists, { namespace: 'profile' })
  walletExists!: boolean;

  @Action('userLogout', { namespace: 'profile' })
  private userLogout!: () => void;

  isFetching = false;
  deleteAccountAcknowledgement = false;

  async deleteUser() {
    if (!this.deleteAccountAcknowledgement) {
      return;
    }

    this.isFetching = true;

    await this.doAuthQuery(async totpToken => {
      await this.$apollo.mutate({
        mutation: deleteUserMutation,
        variables: {
          totpToken,
        },
      });

      this.userLogout();
      this.$router.push('/');
    }, TwoFaCheckpoint.accountDeletion);

    this.isFetching = false;
  }
}
